import clsx from 'clsx';
import { FC, ReactNode } from 'react';

import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Button } from 'src/general/components/Button/Button';

import styles from './CheckoutConfirmPopup.module.scss';

interface Props {
  isOpen: boolean;
  microcopy: {
    title: ReactNode;
    description: ReactNode;
    backButtonLabel: ReactNode;
    continueButtonLabel: ReactNode;
  };
  onClose: () => void;
  onChange: () => void;
}

export const CheckoutConfirmPopup: FC<Props> = ({ microcopy, isOpen, onClose, onChange }) => (
  <BasicModal id="change-payment" title={microcopy.title} isOpen={isOpen} className={styles.root}>
    {microcopy.description}
    <footer className={styles.footer}>
      <Button
        onClick={onClose}
        data-testid="CheckoutConfirmPopup-component-backButton"
        className={clsx(styles.btn, styles.btnGoBack)}
        variant="tertiary"
      >
        {microcopy.backButtonLabel}
      </Button>
      <Button
        onClick={onChange}
        data-testid="CheckoutConfirmPopup-component-continueButton"
        className={clsx(styles.btn, styles.btnContinue)}
        variant="primary"
      >
        {microcopy.continueButtonLabel}
      </Button>
    </footer>
  </BasicModal>
);
